import { NgModule } from "@angular/core";
import { AutoMapperService } from "../../../services/Common/auto-mapper.service";
import { AdminCommonModule } from "../../admin/admin-common.module";
import { DashboardTableComponent } from "./dashboard-table.component";

@NgModule({
    declarations: [
        DashboardTableComponent
    ],
    imports: [
        AdminCommonModule
    ],
    exports: [
        DashboardTableComponent
    ],
    providers: [
        AutoMapperService
    ]
})
export class DashboardTableModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/dashboard-table/dashboard-table.module.ts